export const wizardScreenshots = [
  {
    headerText: "Select Date",
    fileName: {
      mobile: "wizardStep1Mobile.jpg",
      desktop: "wizardStep1.jpg",
    },
    alt: "Booking Wizard Step 1",
  },
  {
    headerText: "Select Products",
    fileName: {
      mobile: "wizardStep2Mobile.jpg",
      desktop: "wizardStep2.jpg",
    },
    alt: "Booking Wizard Step 2",
  },
  {
    headerText: "Select Add-Ons",
    fileName: {
      mobile: "wizardStep3Mobile.jpg",
      desktop: "wizardStep3.jpg",
    },
    alt: "Booking Wizard Step 3",
  },
  {
    headerText: "Customer Details",
    fileName: {
      mobile: "wizardStep4Mobile.jpg",
      desktop: "wizardStep4.jpg",
    },
    alt: "Booking Wizard Step 4",
  },
  {
    headerText: "Sign the Waiver",
    fileName: {
      mobile: "wizardStep5Mobile.jpg",
      desktop: "wizardStep5.jpg",
    },
    alt: "Booking Wizard Step 5",
  },
  {
    headerText: "Payment Details",
    fileName: {
      mobile: "wizardStep6Mobile.jpg",
      desktop: "wizardStep6.jpg",
    },
    alt: "Booking Wizard Step 6",
  },
];